import React from 'react';
import Scheduler from '@common/components/Room/Scheduler/Scheduler';
import RoomDependentWrapperPage from '@common/components/Room/RoomSelectors/RoomDependentWrapperPage';

const SchedulerPage: React.FC = () => {
  return (
    <React.Fragment>
      <RoomDependentWrapperPage scrollable>
        <Scheduler />
      </RoomDependentWrapperPage>
    </React.Fragment>
  );
};

export default SchedulerPage;
